<template>
    <div class="cz3__item-colors" role="group">
        <button
            v-for="c of options"
            :key="c.option.code"
            class="cz3__item-color"
            :class="{
                'cz3__item-color--selected': c.option.code === selected.code && personalizationMethod === method,
                'cz3__item-color--border': c.option.custom && c.option.custom.hex && c.option.custom.hex.toLowerCase().endsWith('ffffff'),
            }"
            :style="getStyle(c)"
            :data-cz-code="c.option.code"
            :aria-pressed="c.option.code === selected.code && personalizationMethod === method"
            :aria-label="c.name"
            :title="c.name"
            @click.prevent="select(c)"
        >
            <span v-if="c.option.custom.image" class="cz3__item-color__background"
                :style="{
                    backgroundImage: `url(&quot;${c.option.custom.image}&quot;)`,
                }"
            >
            </span>
        </button>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__item-colors {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;

            gap: 16px;
        }

        .cz3__item-color {
            position: relative;

            flex: 0 0 auto;

            width: 40px;
            height: 40px;

            border-radius: 40px;
            border: none;

            &:focus {
                outline: 2px solid #000;
                outline-offset: 2px;
            }

            &.cz3__item-color--border {
                border: 2px solid #cbcbcb;
            }

            &.cz3__item-color--selected {
                border: none;

                &:before {
                    content: '';

                    position: absolute;

                    left: -4px;
                    top: -4px;
                    right: -4px;
                    bottom: -4px;

                    border-radius: 40px;
                    border: 2px solid #000;

                    pointer-events: none;
                }
            }

            .cz3__item-color__background {
                position: absolute;

                left: 0;
                top: 0;
                width: 100%;
                height: 100%;

                border-radius: 40px;

                background-size: cover;
                background-repeat: none;
            }
        }
    }
</style>

<script>
    import * as constants from '../../constants';

    export default {
        props: {
            options: Array,
            method: String,
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            selected() {
                const selected = this.viewController.selectedAtPlacement(constants.PLACEMENT_PRODUCT);

                return selected;
            },

            personalizationMethod() {
                return this.$store.state.customizer.personalizationMethod;
            },

            filledPlacements() {
                return this.$store.getters.filledPlacements;
            },
        },

        methods: {
            getStyle(c) {
                const css = {};

                const color = c.option;

                if (color && color.custom && color.custom.hex) {
                    css.backgroundColor = color.custom.hex.startsWith('#') ? color.custom.hex : `#${color.custom.hex}`;
                }

                return css;
            },

            select(c) {
                if (this.method !== this.personalizationMethod && this.filledPlacements.length > 0) {
                    this.$store.dispatch('showGenericConfirm', {
                        title: this.$t('V3_CHANGE_PRINTING_TYPE'),
                        description: this.$t('V3_CHANGE_PRINTING_TYPE_BODY'),
                        cancelAction: this.$t('V3_BACK'),
                        confirmAction: this.$t('V3_CHANGE'),
                        confirmationCallback: () => {
                            [...this.filledPlacements].forEach((p) => {
                                this.$store.dispatch('clearPlacement', p);
                            });

                            this.viewController.updateComponent(constants.PLACEMENT_PRODUCT, c.option.code);

                            this.$store.dispatch('setPersonalizationMethod', this.method);
                        },
                    });
                } else {
                    this.viewController.updateComponent(constants.PLACEMENT_PRODUCT, c.option.code);

                    this.$store.dispatch('setPersonalizationMethod', this.method);
                }
            },
        },
    };
</script>
